import PropTypes from 'prop-types';

import { BenefitsItem } from './BenefitsItem';
import * as Styled from './BenefitsSection.styles';

export function BenefitsList({ items }) {
  return (
    <Styled.BenefitList>
      {items.map((item) => (
        <BenefitsItem key={item.title} item={item} />
      ))}
    </Styled.BenefitList>
  );
}

BenefitsList.propTypes = {
  items: PropTypes.arrayOf(BenefitsItem.propTypes.item).isRequired
};
